/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faThList} from '@fortawesome/pro-duotone-svg-icons';

const MeetingListIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faThList} {...props} />
);

export default MeetingListIcon;
